import { apiLoopsIndex, ApiLoopsIndex } from "apiRoutes/apiLoopsRoutes";
import api, { isSuccess } from "util/api";
import { preloadLooop } from "./fetchAudioFileByUrl";
import { GameRound } from "./types/GameRound";

export default async function preloadGameRound(gameRound: GameRound) {
  const looops = await api<ApiLoopsIndex>(apiLoopsIndex);

  if (!isSuccess(looops)) {
    return;
  }

  await Promise.all(
    looops.response.map((looop) => preloadLooop(looop, gameRound.instruments))
  );
}
